import { useRecoilTransaction_UNSTABLE } from "recoil"

import { getDragBox } from "."
import type { TransactionOperation } from ".."
import { gatherRectanglesWithinBox } from "./gatherWithinBox"
import { startDrag } from "./startDrag"
import { startPointState } from "../../../inputs"
import { findPanelState, panelIndex } from "../../panels"
import { divergeTimeline } from "../../timeline/transactions"
import { activatePanel } from "../activatePanel"

export const finishDragActivate: TransactionOperation = (transactors) => {
  const { set } = transactors
  const dragBox = getDragBox(transactors)
  if (dragBox) {
    const gathered = gatherRectanglesWithinBox(transactors, {
      box: dragBox,
      rectangleStore: [findPanelState, panelIndex],
    })
    const changes = gathered.map((id) => activatePanel(transactors, id))
    divergeTimeline(transactors, changes)
  }
  set(startPointState, null)
}

export const useDragActivate: () => [VoidFunction, VoidFunction] = () => [
  useRecoilTransaction_UNSTABLE((transactors) => () => startDrag(transactors)),
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => finishDragActivate(transactors),
  ),
]
